import React, {useState} from 'react';
import ImageBox from "../buttons/ImageBox";
import Translate from "localization/Translate";
import Button from "../buttons/Button";
import {useSelector} from "react-redux";
import EmergencyButton from "./EmergencyButton";

export default function ({onLiteMode, onFullMode, onCashierMode}) {
    const [view, setView] = useState('mode');

    const connectionHealth = useSelector(state => state.rootReducer.connectionHealth);
    const currentMode = useSelector(state => state.rootReducer.cashierMode ? "cashier" : state.rootReducer.operationMode);

    if(!connectionHealth){
        return (
            <div style={{
                textAlign: 'center',
                display: 'flex',
                flexDirection: 'column'
            }}>
                <div style={{
                    margin: '3.57rem auto',
                }}>
                    <ImageBox
                        image={"iconOfflineMode"}
                        title={<Translate id={'offline mode'}/>}
                        width={'14.29rem'}
                        height={'28.57rem'}
                        boxStyle={{
                            boxSizing: 'border-box',
                            paddingTop: '3.57rem'
                        }}
                        onClick={onCashierMode}
                    />
                </div>
                <span style={{
                    textTransform: 'uppercase',
                    fontWeight: 'bold',
                    fontSize: '1.43rem',
                    marginBottom: '1.43rem'
                }}><Translate id={"Connection failed. Only degraded mode available"}/></span>
                <span style={{
                    fontWeight: 'bold'
                }}><Translate id={"NOTE: Some functionalities might be limited or not available in this mode."}/></span>
            </div>
        );
    }

    const unifiedVersion = window?.AppConf?.unifiedVersion ?? false;

    if(unifiedVersion && view === 'mode' && currentMode !== "cashier"){
        return (<div style={{
            textAlign: 'center'
        }}>
            <EmergencyButton/>
            <div style={{
                marginTop: '3.57rem',
                display: 'inline-block'
            }}>
                <ImageBox
                    image={"iconCashierMode"}
                    title={<Translate id={'cashier mode'}/>}
                    width={'14.29rem'}
                    height={'28.57rem'}
                    boxStyle={{
                        boxSizing: 'border-box',
                        paddingTop: '3.57rem'
                    }}
                    onClick={onCashierMode}
                />
                <ImageBox
                    image={"iconFullMode"}
                    title={<Translate id={'sco mode'}/>}
                    width={'14.29rem'}
                    height={'28.57rem'}
                    containerStyle={{
                        marginLeft: '7.14rem'
                    }}
                    boxStyle={{
                        boxSizing: 'border-box',
                        paddingTop: '5.36rem'
                    }}
                    onClick={() => {
                        setView('sco');
                    }}
                />
            </div>
        </div>);
    }

    let backButton;
    if(unifiedVersion && currentMode !== "cashier"){
        backButton = <div onClick={() => {
            setView('mode');
        }} style={{marginTop: '0.71rem', marginBottom: '0.71rem'}}>
            <Button type="button" className={"largeButton grayButton"} name={<Translate id="back"/>}
                    arrow="left" flencheClass={"flencheSmallLeftBottom grayFlenche"}/>
        </div>;
    }

    let liteMode;
    if(currentMode !== "lite"){
        liteMode = <ImageBox
            image={"iconLiteMode"}
            title={<Translate id={'lite mode'}/>}
            width={'14.29rem'}
            height={'28.57rem'}
            boxStyle={{
                boxSizing: 'border-box',
                paddingTop: '3.57rem'
            }}
            onClick={onLiteMode}
        />;
    }

    let fullMode;
    if(currentMode !== "full"){
        fullMode = <ImageBox
            image={"iconFullMode"}
            title={<Translate id={'full mode'}/>}
            width={'14.29rem'}
            height={'28.57rem'}
            containerStyle={{
                marginLeft: '7.14rem'
            }}
            boxStyle={{
                boxSizing: 'border-box',
                paddingTop: '5.36rem'
            }}
            onClick={onFullMode}
        />;
    }

    return (
        <div style={{
            textAlign: 'center'
        }}>
            <EmergencyButton/>
            <div style={{
                marginTop: '3.57rem',
                display: 'inline-block'
            }}>
                { liteMode }
                { fullMode }
            </div>
            {backButton}
        </div>
    );
}